module.exports = __webpack_public_path__ + "19c10ba6dea77a2eaa1467cdde314b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-768.jpg
// module id = 347
// module chunks = 0